import { Outlet } from 'react-router-dom';

export const EventOutlet = () => <Outlet />;
